/* Phone Time — Shop panel behaviour (header mega menu + full-screen sheet). Dependency-free; delegated so it survives header re-renders. */
(function () {
  'use strict';
  var doc = document;

  function qa(sel, root) { return Array.prototype.slice.call((root || doc).querySelectorAll(sel)); }
  function norm(s) { return String(s || '').toLowerCase().replace(/[^a-z0-9]+/g, ''); }

  /* ---- category: device-specific ones show the model picker, the rest show their own sub-category pane ---- */
  function setCat(root, cat) {
    var base = root.getAttribute('data-collections-url') || '/collections';
    var key = cat.getAttribute('data-pt-cat');
    var type = cat.getAttribute('data-type');
    root.setAttribute('data-cat', key);
    qa('[data-pt-cat]', root).forEach(function (a) {
      var on = a === cat;
      a.classList.toggle('is-active', on);
      if (on) a.setAttribute('aria-current', 'true'); else a.removeAttribute('aria-current');
    });
    var paneKey = type === 'models' ? 'models' : key;
    qa('[data-pt-pane]', root).forEach(function (p) { p.hidden = p.getAttribute('data-pt-pane') !== paneKey; });
    if (type === 'models') {
      qa('[data-pt-model]', root).forEach(function (a) {
        a.setAttribute('href', base + '/' + key + '/' + a.getAttribute('data-handle'));
      });
      qa('[data-pt-styles]', root).forEach(function (s) { s.hidden = s.getAttribute('data-pt-styles') !== key; });
      var title = root.querySelector('[data-pt-ptitle]');
      if (title) title.textContent = cat.getAttribute('data-label');
      var all = root.querySelector('[data-pt-cat-all]');
      if (all) {
        all.setAttribute('href', cat.getAttribute('href'));
        var label = all.querySelector('[data-label]');
        if (label) label.textContent = 'View all ' + cat.getAttribute('data-label');
      }
    }
  }

  /* ---- brand tabs ---- */
  function setGroup(root, id) {
    qa('[data-pt-gtab]', root).forEach(function (t) {
      var on = t.getAttribute('data-pt-gtab') === id;
      t.setAttribute('aria-selected', on ? 'true' : 'false');
      t.tabIndex = on ? 0 : -1;
    });
    qa('[data-pt-group]', root).forEach(function (g) {
      g.classList.toggle('is-active', g.getAttribute('data-pt-group') === id);
    });
  }

  /* ---- live search (always searches the model picker) ---- */
  function filter(root, q) {
    var tokens = String(q || '').toLowerCase().split(/\s+/).map(norm).filter(Boolean);
    var searching = tokens.length > 0;
    var any = false;
    var wasSearching = root.classList.contains('is-searching');
    root.classList.toggle('is-searching', searching);

    if (searching && !wasSearching) {
      // remember where we were, and show the model picker for the first device-specific category if we are on another pane
      root.__ptPrev = root.querySelector('[data-pt-cat].is-active');
      var onModels = root.__ptPrev && root.__ptPrev.getAttribute('data-type') === 'models';
      if (!onModels) {
        var firstModels = root.querySelector('[data-pt-cat][data-type="models"]');
        if (firstModels) setCat(root, firstModels);
      }
    } else if (!searching && wasSearching && root.__ptPrev) {
      setCat(root, root.__ptPrev);
      root.__ptPrev = null;
    }

    qa('[data-pt-group]', root).forEach(function (brand) {
      var brandVisible = false;
      qa('[data-pt-subgroup]', brand).forEach(function (g) {
        var visible = false;
        qa('[data-pt-model]', g).forEach(function (a) {
          var n = a.__ptn || (a.__ptn = norm(a.getAttribute('data-name')));
          var ok = tokens.every(function (t) { return n.indexOf(t) > -1; });
          a.parentNode.hidden = !ok;
          if (ok) visible = true;
        });
        g.hidden = !visible;
        if (visible) brandVisible = true;
      });
      brand.hidden = !brandVisible;
      if (brandVisible) any = true;
    });
    var empty = root.querySelector('[data-pt-finder-empty]');
    if (empty) {
      empty.hidden = !(searching && !any);
      var slot = empty.querySelector('[data-q]');
      if (slot) slot.textContent = q;
    }
  }

  /* ---- mark the model of the page we are on, and open the matching brand tab ---- */
  function markCurrent(root) {
    if (root.__ptInit) return;
    root.__ptInit = true;
    var m = location.pathname.match(/\/collections\/([^/]+)\/([^/]+)\/?$/);
    if (!m) return;
    var handle = decodeURIComponent(m[2]);
    var link = root.querySelector('[data-pt-model][data-handle="' + handle.replace(/"/g, '') + '"]');
    if (!link) return;
    link.setAttribute('aria-current', 'page');
    var group = link.closest('[data-pt-group]');
    if (group) setGroup(root, group.getAttribute('data-pt-group'));
  }

  /* ---- sheet ---- */
  var lastFocus = null;
  function openSheet(start) {
    var m = doc.querySelector('[data-pt-finder-modal]');
    if (!m) return;
    lastFocus = doc.activeElement;
    m.hidden = false;
    if (start) {
      var root = m.querySelector('[data-pt-finder]');
      var cat = root && root.querySelector('[data-pt-cat="' + String(start).replace(/"/g, '') + '"]');
      if (cat) setCat(root, cat);
    }
    doc.documentElement.classList.add('pt-lock');
    var sheet = m.querySelector('.pt-fm__sheet');
    if (sheet && sheet.focus) sheet.focus({ preventScroll: true });
  }
  function closeSheet() {
    var m = doc.querySelector('[data-pt-finder-modal]');
    if (!m || m.hidden) return;
    m.hidden = true;
    doc.documentElement.classList.remove('pt-lock');
    if (lastFocus && lastFocus.focus) { try { lastFocus.focus({ preventScroll: true }); } catch (e) { /* ignore */ } }
  }

  doc.addEventListener('click', function (e) {
    var t = e.target;
    if (!t || !t.closest) return;

    var opener = t.closest('[data-pt-open-finder]');
    if (opener) {
      e.preventDefault();
      // if the mobile menu is open, close it first
      if (doc.querySelector('#Details-menu-drawer-container[open]')) {
        var x = doc.querySelector('.menu-drawer__close-button');
        if (x) x.click();
      }
      openSheet(opener.getAttribute('data-pt-start'));
      return;
    }
    if (t.closest('[data-pt-finder-close]')) { closeSheet(); return; }

    var cat = t.closest('[data-pt-cat]');
    if (cat) {
      var root = cat.closest('[data-pt-finder]');
      if (root && root.getAttribute('data-mode') === 'modal') { e.preventDefault(); setCat(root, cat); }
      return;
    }
    var tab = t.closest('[data-pt-gtab]');
    if (tab) setGroup(tab.closest('[data-pt-finder]'), tab.getAttribute('data-pt-gtab'));
  });

  /* hover (desktop menu): short delay so a diagonal mouse path does not flip panes */
  var hoverTimer = null;
  function hoverCat(e) {
    var t = e.target;
    if (!t || !t.closest || e.pointerType === 'touch') return;
    var cat = t.closest('[data-pt-cat]');
    if (!cat) return;
    var root = cat.closest('[data-pt-finder]');
    if (!root || root.getAttribute('data-mode') !== 'menu' || cat.classList.contains('is-active')) return;
    clearTimeout(hoverTimer);
    if (e.type === 'focusin') { setCat(root, cat); return; }
    hoverTimer = setTimeout(function () { setCat(root, cat); }, 60);
  }
  doc.addEventListener('pointerover', hoverCat);
  doc.addEventListener('focusin', hoverCat);
  doc.addEventListener('pointerout', function (e) {
    var t = e.target;
    if (t && t.closest && t.closest('[data-pt-cat]')) clearTimeout(hoverTimer);
  });

  doc.addEventListener('input', function (e) {
    var i = e.target;
    if (i && i.matches && i.matches('[data-pt-finder-search]')) filter(i.closest('[data-pt-finder]'), i.value);
  });
  doc.addEventListener('keydown', function (e) {
    if (e.key === 'Escape') { closeSheet(); return; }
    var i = e.target;
    if (e.key === 'Enter' && i && i.matches && i.matches('[data-pt-finder-search]')) {
      var root = i.closest('[data-pt-finder]');
      var first = qa('[data-pt-model]', root).filter(function (a) { return !a.parentNode.hidden && !a.closest('[hidden]'); })[0];
      if (first && i.value.trim()) { e.preventDefault(); window.location.href = first.getAttribute('href'); }
    }
  });

  function init() { qa('[data-pt-finder]').forEach(markCurrent); }
  if (doc.readyState === 'loading') doc.addEventListener('DOMContentLoaded', init); else init();
  doc.addEventListener('shopify:section:load', init);
  doc.addEventListener('shopify:section:unload', closeSheet);
})();
